<template>
  <section class="activetime-by-typecomponent">
    <div class="activetime-by-typecomponent__header">
      <div class="activetime-by-typecomponent__header__container">
        <div class="menu-switch-buttons">
          <div
            :class="selectedComponent == 'ActiveTimeByTypeTeamComponent' ? 'active-menu-switch-buttons' : ''"
            class="menu-switch-buttons__teams "
            @click="onSectionSelect('ActiveTimeByTypeTeamComponent')"
          >
            Equipos
          </div>
          <div
            :class="selectedComponent == 'ActiveTimeByTypeReefereComponent' ? 'active-menu-switch-buttons' : ''"
            class="menu-switch-buttons__reefere"
            @click="onSectionSelect('ActiveTimeByTypeReefereComponent')"
          >
            Arbitros
          </div>
          <div
            :class="selectedComponent == 'ActiveTimeByTypeEventsComponent' ? 'active-menu-switch-buttons' : ''"
            class="menu-switch-buttons__events"
            @click="onSectionSelect('ActiveTimeByTypeEventsComponent')"
          >
            Eventos
          </div>
        </div>
      </div>
      <div class="activetime-by-typecomponent__header__separator"></div>
    </div>
    <div class="activetime-by-typecomponent__container-sections">
      <KeepAlive>
        <Component
          :is="selectedComponent"
          @show="show"
          :actions="actions"
          :matchdays="matchdays"
          :teams="teamsData"
          :referees="refereesData"
          :events="eventsData"
          :match="filterMatch"
          :action="filterEvent"
          @onChangeMatch="onChangeMatch"
          @onChangeAction="onChangeAction"
          @orderReferee="orderReferee"
          @orderTeams="orderTeams"
          @orderRefereeSection="orderRefereeSection"
          @orderTeamSection="orderTeamSection"
        />
      </KeepAlive>
      <div class="activetime-by-typecomponent__container-sections__drawer" :class="{ active: openLayer }">
        <div class="filter-drawer" :class="{ active: openDrawer }">
          <AvancedFilterActiveTimeByType @show="show" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ActiveTimeByTypeComponent',
  components: {
    AvancedFilterActiveTimeByType: () => import('@/components/ActiveTime/Elements/AvancedFilterActiveTimeByType'),
    ActiveTimeByTypeTeamComponent: () => import('@/components/ActiveTime/ActiveTimeByTypeTeamComponent'),
    ActiveTimeByTypeEventsComponent: () => import('@/components/ActiveTime/ActiveTimeByTypeEventsComponent'),
    ActiveTimeByTypeReefereComponent: () => import('@/components/ActiveTime/ActiveTimeByTypeReefereComponent'),
  },
  props: {
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    seasons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: 'https://qks69mcf5i.execute-api.us-east-2.amazonaws.com/prod/ta/events-per-matchday/',
      selectedComponent: 'ActiveTimeByTypeTeamComponent',
      openLayer: false,
      openDrawer: false,
      matchdays: [],
      actions: [],
      teams: [],
      teamsaux: [],
      referees: [],
      refereesaux: [],
      teamseventsaux: [],
      refereeseventsaux: [],
      events: [],
      filterMatch: 0,
      filterEvent: 5,
      orderRefereeT: 1,
      orderRefereeE: -1,
      orderTeamT: 1,
      orderTeamE: -1,
      orderRefereeSTA: 0,
      orderRefereeSTI: -1,
      orderTeamSTA: 0,
      orderTeamSTI: -1,
    };
  },
  computed: {
    eventsData() {
      let clonedRefereeEventsData = JSON.parse(JSON.stringify(this.refereeseventsaux));
      let clonedTeamsEventsData = JSON.parse(JSON.stringify(this.teamseventsaux));
      var arrayfilterReferee = {};
      var arrayfilterTeams = {};
      for (let indexN = 0; indexN < clonedRefereeEventsData.length; indexN++) {
        if (
          this.filterEvent == clonedRefereeEventsData[indexN].action_id &&
          this.filterMatch == clonedRefereeEventsData[indexN].matchday
        ) {
          if (!arrayfilterReferee[clonedRefereeEventsData[indexN].id]) {
            arrayfilterReferee[clonedRefereeEventsData[indexN].id] = {};
            arrayfilterReferee[clonedRefereeEventsData[indexN].id] = clonedRefereeEventsData[indexN];
          } else {
            arrayfilterReferee[clonedRefereeEventsData[indexN].id].time_seg += clonedRefereeEventsData[indexN].time_seg;
          }
        }
      }
      for (let indexN = 0; indexN < clonedTeamsEventsData.length; indexN++) {
        if (
          this.filterEvent == clonedTeamsEventsData[indexN].action_id &&
          this.filterMatch == clonedTeamsEventsData[indexN].matchday
        ) {
          if (!arrayfilterTeams[clonedTeamsEventsData[indexN].id]) {
            arrayfilterTeams[clonedTeamsEventsData[indexN].id] = {};
            arrayfilterTeams[clonedTeamsEventsData[indexN].id] = clonedTeamsEventsData[indexN];
          } else {
            arrayfilterTeams[clonedTeamsEventsData[indexN].id].time_seg += clonedTeamsEventsData[indexN].time_seg;
          }
        }
      }

      var arrayfilterFinalReferee = this.changeObjToArray(arrayfilterReferee);
      if (this.orderRefereeT >= 0) {
        if (this.orderRefereeT == 1) {
          arrayfilterFinalReferee = this.orderArrayRefereeSort(arrayfilterFinalReferee, 1);
        } else {
          arrayfilterFinalReferee = this.orderArrayRefereeASort(arrayfilterFinalReferee, 1);
        }
      } else {
        if (this.orderRefereeE >= 0) {
          if (this.orderRefereeE == 1) {
            arrayfilterFinalReferee = this.orderArrayRefereeSort(arrayfilterFinalReferee, 0);
          } else {
            arrayfilterFinalReferee = this.orderArrayRefereeASort(arrayfilterFinalReferee, 0);
          }
        }
      }

      arrayfilterFinalReferee = this.getPositionsArray(arrayfilterFinalReferee);
      arrayfilterFinalReferee = this.getArraSliderEvents(arrayfilterFinalReferee);

      var arrayfilterFinalteams = this.changeObjToArray(arrayfilterTeams);
      if (this.orderTeamT >= 0) {
        if (this.orderTeamT == 1) {
          arrayfilterFinalteams = this.orderArrayRefereeSort(arrayfilterFinalteams, 1);
        } else {
          arrayfilterFinalteams = this.orderArrayRefereeASort(arrayfilterFinalteams, 1);
        }
      } else {
        if (this.orderTeamE >= 0) {
          if (this.orderTeamE == 1) {
            arrayfilterFinalteams = this.orderArrayRefereeSort(arrayfilterFinalteams, 0);
          } else {
            arrayfilterFinalteams = this.orderArrayRefereeASort(arrayfilterFinalteams, 0);
          }
        }
      }
      arrayfilterFinalteams = this.getPositionsArray(arrayfilterFinalteams);
      arrayfilterFinalteams = this.getArraSliderEvents(arrayfilterFinalteams);
      return { referees: arrayfilterFinalReferee, teams: arrayfilterFinalteams };
    },
    refereesData() {
      let clonedRefereeData = JSON.parse(JSON.stringify(this.refereesaux));
      var arrayfilter = {};
      for (let indexM = 0; indexM < clonedRefereeData.length; indexM++) {
        if (clonedRefereeData[indexM].matchday == this.filterMatch) {
          if (!arrayfilter[clonedRefereeData[indexM].id]) {
            arrayfilter[clonedRefereeData[indexM].id] = {};
            arrayfilter[clonedRefereeData[indexM].id] = clonedRefereeData[indexM];
          }
        }
      }
      var arrayfilterFinal = this.changeObjToArray(arrayfilter);

      if (this.orderRefereeSTA >= 0) {
        if (this.orderRefereeSTA == 1) {
          arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 1, 'ta');
        } else {
          arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 0, 'ta');
        }
      } else {
        if (this.orderRefereeSTI >= 0) {
          if (this.orderRefereeSTI == 1) {
            arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 1, 'taper_number');
          } else {
            arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 0, 'taper_number');
          }
        }
      }

      arrayfilterFinal = this.getPositionsArray(arrayfilterFinal);
      arrayfilterFinal = this.getArraSlider(arrayfilterFinal);
      return arrayfilterFinal;
    },
    teamsData() {
      let clonedTeamsData = JSON.parse(JSON.stringify(this.teamsaux));
      var arrayfilter = {};
      for (let indexM = 0; indexM < clonedTeamsData.length; indexM++) {
        if (clonedTeamsData[indexM].matchday == this.filterMatch) {
          if (!arrayfilter[clonedTeamsData[indexM].id]) {
            arrayfilter[clonedTeamsData[indexM].id] = {};
            arrayfilter[clonedTeamsData[indexM].id] = clonedTeamsData[indexM];
          }
        }
      }
      var arrayfilterFinal = this.changeObjToArray(arrayfilter);

      if (this.orderTeamSTA >= 0) {
        if (this.orderTeamSTA == 1) {
          arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 1, 'ta');
        } else {
          arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 0, 'ta');
        }
      } else {
        if (this.orderTeamSTI >= 0) {
          if (this.orderTeamSTI == 1) {
            arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 1, 'ti');
          } else {
            arrayfilterFinal = this.orderArraySort(arrayfilterFinal, 0, 'ti');
          }
        }
      }
      arrayfilterFinal = this.getPositionsArray(arrayfilterFinal);
      arrayfilterFinal = this.getArraSlider(arrayfilterFinal);
      return arrayfilterFinal;
    },
  },
  watch: {
    seasons: {
      immediate: true,
      deep: true,
      handler: async function(newValue) {
        if (newValue && newValue.length) {
          const season = newValue.filter(season => season.type === 0)[0];
          await this.getEvents(season.id);
        }
      },
    },
  },
  methods: {
    orderTeamSection(val) {
      if (val.type == 'ta') {
        this.orderTeamSTA = val.order;
        this.orderTeamSTI = -1;
      } else {
        this.orderTeamSTA = -1;
        this.orderTeamSTI = val.order;
      }
    },
    orderRefereeSection(val) {
      if (val.type == 'ta') {
        this.orderRefereeSTA = val.order;
        this.orderRefereeSTI = -1;
      } else {
        this.orderRefereeSTA = -1;
        this.orderRefereeSTI = val.order;
      }
    },
    orderReferee(val) {
      if (val.type == 'time') {
        this.orderRefereeT = val.order;
        this.orderRefereeE = -1;
      } else {
        this.orderRefereeT = -1;
        this.orderRefereeE = val.order;
      }
    },
    orderTeams(val) {
      if (val.type == 'time') {
        this.orderTeamT = val.order;
        this.orderTeamE = -1;
      } else {
        this.orderTeamT = -1;
        this.orderTeamE = val.order;
      }
    },
    onChangeMatch(match) {
      this.filterMatch = match;
    },
    onChangeAction(action) {
      this.filterEvent = action;
    },
    onSectionSelect(sectionComponent) {
      this.selectedComponent = sectionComponent;
    },
    hideDrawer() {
      this.openDrawer = false;
      setTimeout(() => {
        this.openLayer = false;
      }, 500);
    },
    show(flag) {
      if (flag) {
        this.openLayer = true;
        setTimeout(() => {
          this.openDrawer = true;
        }, 100);
      } else {
        this.openDrawer = false;
        setTimeout(() => {
          this.openLayer = false;
        }, 500);
      }
    },
    changeNameReferee(name) {
      if (name === 'Sin designar') {
        return name;
      }
      let nameRefereePrint = '';
      if (name != null) {
        let nameTrim = name.trim();
        let auxReferee = nameTrim.split(', ');
        let apellidoAuxReferee = auxReferee[0].split(' ');
        let nameAuxReferee = auxReferee[1].split(' ');
        let auxNameInitials = '';
        for (let index = 0; index < nameAuxReferee.length; index++) {
          auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
        }
        nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
      }
      return nameRefereePrint;
    },
    async getEvents(season) {
      const dataEvents = await axios
        .get(this.url + season)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getEvents(season);
          }
          return e;
        });
      this.matchdays = [];
      this.actions = [];
      this.teamsaux = [];
      this.refereesaux = [];
      this.teamseventsaux = [];
      this.refereeseventsaux = [];
      this.filterMatch = 0;
      if (dataEvents.data != '') {
        for (let index = 0; index < dataEvents.data.matchdays.length; index++) {
          this.matchdays.push({
            id: dataEvents.data.matchdays[index].matchday_id,
            name:
              dataEvents.data.matchdays[index].matchday_id == 18
                ? 'Cuartos de final Ida'
                : dataEvents.data.matchdays[index].matchday_id == 19
                ? 'Cuartos de final Vuelta'
                : dataEvents.data.matchdays[index].matchday_id == 20
                ? 'Semifinal Ida'
                : dataEvents.data.matchdays[index].matchday_id == 21
                ? 'Semifinal Vuelta'
                : dataEvents.data.matchdays[index].matchday_id == 22
                ? 'Final Ida'
                : dataEvents.data.matchdays[index].matchday_id == 86
                ? 'Final Vuelta'
                : dataEvents.data.matchdays[index].matchday_id == 1800
                ? 'Repechaje'
                : dataEvents.data.matchdays[index].matchday_name.replace('Matchday', 'Jornada'),
          });
        }
        for (let index = 0; index < dataEvents.data.actions.length; index++) {
          if (dataEvents.data.actions[index].action_id != 11 && dataEvents.data.actions[index].action_id != 12) {
            this.actions.push({
              id: dataEvents.data.actions[index].action_id,
              name: dataEvents.data.actions[index].name,
            });
          }
        }
        for (let index = 0; index < dataEvents.data.teams.length; index++) {
          this.teamsaux.push({
            pos: index + 1 < 10 ? '0' + (index + 1) + '.' : index + 1 + '.',
            logo: 'https://golstatsimages.blob.core.windows.net/teams-80/' + dataEvents.data.teams[index].team_id + '.png',
            name: dataEvents.data.teams[index].team_name,
            ta: dataEvents.data.teams[index].te,
            ti: dataEvents.data.teams[index].ti,
            id: dataEvents.data.teams[index].team_id,
            ta_secs: dataEvents.data.teams[index].te_secs,
            ti_secs: dataEvents.data.teams[index].ti_secs,
            matchday: dataEvents.data.teams[index].matchday_id,
          });
        }

        for (let index = 0; index < dataEvents.data.referees.length; index++) {
          this.refereesaux.push({
            pos: index + 1 < 10 ? '0' + (index + 1) + '.' : index + 1 + '.',
            logo: 'https://golstatsimages.blob.core.windows.net/photo-referee/' + dataEvents.data.referees[index].referee_id + '.jpg',
            name: this.changeNameReferee(dataEvents.data.referees[index].referee_name),
            ta: dataEvents.data.referees[index].te,
            taper: dataEvents.data.referees[index].te_average,
            id: dataEvents.data.referees[index].referee_id,
            ta_secs: dataEvents.data.referees[index].te_secs,
            taper_number: dataEvents.data.referees[index].te_average_numbers,
            matchday: dataEvents.data.referees[index].matchday_id,
          });
        }

        for (let index = 0; index < dataEvents.data.events.teams.length; index++) {
          var aTeams = dataEvents.data.events.teams[index].time.split(':');
          var secondsTeams = aTeams[0] * 60 + aTeams[1];
          this.teamseventsaux.push({
            pos: index + 1 < 10 ? '0' + (index + 1) + '.' : index + 1 + '.',
            logo: 'https://golstatsimages.blob.core.windows.net/teams-80/' + dataEvents.data.events.teams[index].team_id + '.png',
            name: dataEvents.data.events.teams[index].team_name,
            time: dataEvents.data.events.teams[index].time,
            time_seg: secondsTeams,
            average: dataEvents.data.events.teams[index].action_average,
            id: dataEvents.data.events.teams[index].team_id,
            action_id: dataEvents.data.events.teams[index].action_id,
            game_id: dataEvents.data.events.teams[index].game_id,
            matchday: dataEvents.data.events.teams[index].matchday_id,
          });
        }

        for (let index = 0; index < dataEvents.data.events.referees.length; index++) {
          var a = dataEvents.data.events.referees[index].time.split(':');
          var seconds = a[0] * 60 + a[1];
          this.refereeseventsaux.push({
            pos: index + 1 < 10 ? '0' + (index + 1) + '.' : index + 1 + '.',
            logo:
              'https://golstatsimages.blob.core.windows.net/photo-referee/' +
              dataEvents.data.events.referees[index].referee_id +
              '.jpg',
            name: this.changeNameReferee(dataEvents.data.events.referees[index].referee_name),
            time: dataEvents.data.events.referees[index].time,
            time_seg: seconds,
            average: dataEvents.data.events.referees[index].action_average,
            id: dataEvents.data.events.referees[index].referee_id,
            game_id: dataEvents.data.events.referees[index].game_id,
            action_id: dataEvents.data.events.referees[index].action_id,
            matchday: dataEvents.data.events.referees[index].matchday_id,
          });
        }
      }
    },
    getArraSliderEvents(arrayData) {
      var indexPag = 0;
      var arrayDataPage = [];
      for (const index in arrayData) {
        if (!arrayDataPage[indexPag]) {
          arrayDataPage[indexPag] = [];
        }
        if (arrayDataPage[indexPag].length < 3) {
          arrayDataPage[indexPag].push(arrayData[index]);
        } else {
          indexPag += 1;
          if (!arrayDataPage[indexPag]) {
            arrayDataPage[indexPag] = [];
          }
          arrayDataPage[indexPag].push(arrayData[index]);
        }
      }
      return arrayDataPage;
    },
    getArraSlider(arrayData) {
      var indexPag = 0;
      var arrayDataPage = [];
      for (const index in arrayData) {
        if (!arrayDataPage[indexPag]) {
          arrayDataPage[indexPag] = [];
        }
        if (arrayDataPage[indexPag].length < 6) {
          arrayDataPage[indexPag].push(arrayData[index]);
        } else {
          indexPag += 1;
          if (!arrayDataPage[indexPag]) {
            arrayDataPage[indexPag] = [];
          }
          arrayDataPage[indexPag].push(arrayData[index]);
        }
      }
      return arrayDataPage;
    },
    fmtMSS(s) {
      var time = (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
      var timeIndex = time.indexOf('.');
      var timeFormatt = time.slice(0, timeIndex);
      var timeFinal = timeFormatt.length < 4 ? timeFormatt + '0' : timeFormatt;
      return timeFinal;
    },
    getPositionsArray(arrayData) {
      for (let index = 0; index < arrayData.length; index++) {
        arrayData[index].pos = index + 1 < 10 ? '0' + (index + 1) + '.' : index + 1 + '.';
      }
      return arrayData;
    },
    changeObjToArray(arrayData) {
      return Object.keys(arrayData).map(key => arrayData[key]);
    },
    orderArrayRefereeSort(arrayData, type) {
      let array = [];
      if (type == 1) {
        array = arrayData.sort((a, b) => (a.time > b.time ? 1 : b.time > a.time ? -1 : 0)); //menor a mayor
      } else {
        array = arrayData.sort((a, b) => (a.average > b.average ? 1 : b.average > a.average ? -1 : 0)); //menor a mayor
      }
      return array;
    },
    orderArrayRefereeASort(arrayData, type) {
      let array = [];
      if (type == 1) {
        array = arrayData.sort((a, b) => (a.time < b.time ? 1 : b.time < a.time ? -1 : 0)); //menor a mayor
      } else {
        array = arrayData.sort((a, b) => (a.average < b.average ? 1 : b.average < a.average ? -1 : 0)); //menor a mayor
      }
      return array;
    },
    orderArraySort(arrayData, typeOrder, fieldType) {
      if (typeOrder === 1) {
        return arrayData.sort((a, b) => (a[fieldType] > b[fieldType] ? 1 : b[fieldType] > a[fieldType] ? -1 : 0)); //menor a mayor
      } else {
        return arrayData.sort((a, b) => (a[fieldType] < b[fieldType] ? 1 : b[fieldType] < a[fieldType] ? -1 : 0)); //menor a mayor
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-advanced-activetime-by-typecomponent {
  width: 100%;
  height: 380px;
}
.active-menu-switch-buttons {
  background: #cbee6a;
  color: #132739 !important;
  cursor: default !important;
}
.menu-switch-buttons {
  width: 90%;
  height: 29px;
  display: inline-flex;
  margin-left: 5%;
  border-radius: 4px;
  overflow: hidden;
  font-family: 'Circular-Std-Book';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 29px;
  letter-spacing: -0.32px;
  text-align: center;
  border: solid 1px #cbfb48;
  &__teams {
    width: 33.33%;
    color: #cbee6a;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
  &__reefere {
    width: 33.33%;
    color: #cbee6a;
    border-right: 1px solid #cbfb48;
    border-left: 1px solid #cbfb48;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
  &__events {
    width: 33.33%;
    color: #cbee6a;
    &:hover {
      background: #cbee6a;
      color: #132739;
      cursor: pointer;
    }
  }
}
.activetime-by-typecomponent {
  width: 100%;
  height: 402px;
  background: rgb(255, 254, 254);
  border-radius: 4px;
  position: relative;
  &__header {
    width: 100%;
    height: 46px;
    display: inline-block;
    &__container {
      width: 100%;
      height: 44px;
      background: #132739;
      display: inline-flex;
      align-content: center;
      align-items: center;
    }

    &__separator {
      width: 100%;
      height: 2px;
      background: #cbfb48;
    }
  }
  &__container-sections {
    width: 100%;
    height: 356px;
    border: solid 1px #d0d4d7;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    &__drawer {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.7);
      padding: 10px;
      justify-content: flex-end;
      display: none;
      height: 402px;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
      margin: 0px 0px;
      padding: 0px;
      // @media screen and (max-width: 500px) {
      //   height: 455px;
      // }
      // @media screen and (max-width: 370px) {
      //   margin: 259px 0px;
      // }

      &.active {
        // @media screen and (max-width: 500px) {
        display: flex;
        // }
      }
      .filter-drawer {
        background-color: white;
        width: 0px;
        overflow: hidden;
        transition: all 0.5s ease-in-out;
        opacity: 0;
        position: relative;
        &.active {
          width: 100%;
          opacity: 1;
          height: 402px;
        }

        .close-btn {
          position: absolute;
          top: 10px;
          left: 21px;
          width: 25px;
          height: 25px;
          color: white;
          display: flex;
          justify-content: center;
          border-radius: 4px;
          background-color: #3b3b3b;
          align-items: center;
          font-size: 21px;
          cursor: pointer;
          line-height: 19px;
          outline: none;
          border: none;
        }
      }
    }
  }
}
</style>
